// Translation: Turkish > Terminology
const terminology = Object.freeze({
	agent: 'Ajan',
	agent_one: 'Ajan',
	agent_other: 'Ajanlar',
	agents: 'Ajanlar',
	agentStatusItems: {
		deleted: 'Silinmiş',
		draft: 'Taslak',
		onboarded: 'Eklendi'
	},
	agentWithCount: '{{count}} ajan',
	agentWithId: 'Ajan {{id}}',
	asset: 'Nesne',
	asset_one: 'Nesne',
	asset_other: 'Nesneler',
	assets: 'Nesneler',
	assetWithCount: '{{count}} nesne',
	assetWithVersion: '{{name}} [{{version}}]',
	automode: 'AutoMode',
	benchmark: 'Kıyaslama',
	benchmark_one: 'Kıyaslama',
	benchmark_other: 'Kıyaslamalar',
	benchmarks: 'Kıyaslamalar',
	benchmarkStatusItems: {
		calculate_scores: 'Hesaplanıyor',
		completed: 'Tamamlandı',
		failed: 'Başarısız',
		in_progress: 'İşleniyor'
	},
	benchmarkWithCount: '{{count}} kıyaslama',
	benchmarkWithId: 'Benchmark {{id}}',
	categories: 'Kategoriler',
	category: 'Kategori',
	category_one: 'Kategori',
	category_other: 'Kategoriler',
	categoryWithCount: '{{count}} kategori',
	character: 'Karakter',
	character_one: 'Karakter',
	character_other: 'Karakterler',
	characters: 'Karakterler',
	characterWithCount: '{{count}} karakter',
	column: 'Sütun',
	column_one: 'Sütun',
	column_other: 'Sütunlar',
	columns: 'Sütunlar',
	columnWithCount: '{{count}} sütun',
	corpora: 'Korpuslar',
	corpus: 'Korpus',
	corpus_one: 'Korpus',
	corpus_other: 'Korpuslar',
	corpusPrivacyTypeItems: {
		Private: 'Özel',
		Public: 'Herkese açık'
	},
	corpusStatusItems: {
		deleted: 'Silinmiş',
		failed: 'Başarısız',
		onboarded: '__Eklendi',
		onboarding: '__Ekleniyor'
	},
	corpusWithCount: '{{count}} korpus',
	corpusWithId: 'Korpus {{id}}',
	credit: 'Kredi',
	credit_one: 'Kredi',
	credit_other: 'Kredi',
	creditAsRange: '{{low}}–{{high}} kredi',
	credits: 'Krediler',
	creditWithCount: '{{count}} kredi',
	data: 'Veri',
	dataset: 'Veri seti',
	dataset_one: 'Veri seti',
	dataset_other: 'Veri setleri',
	datasetMetadataTypeItems: {
		age: 'Yaş',
		gender: 'Cinsiyet',
		other: 'Diğer',
		race: 'Irk',
		split: '__Ayrık',
		topic: 'Konu'
	},
	datasets: 'Veri setleri',
	datasetStatusItems: {
		deleted: 'Silinmiş',
		failed: 'Başarısız',
		onboarded: '__Eklendi',
		onboarding: '__Ekleniyor'
	},
	datasetUsageTypeItems: {
		development: 'Geliştirme',
		developmentInShort: '__Geliştirme',
		training: 'Eğitim',
		trainingInShort: '__Eğitim'
	},
	datasetWithCount: '{{count}} veri seti',
	datasetWithFunction: '{{function}} veri seti',
	datasetWithId: 'Veri seti {{id}}',
	dataSubTypeItems: {
		boolean: 'Boole damgası',
		file: 'Dosya',
		json: 'JSON',
		labeledImage: 'Etiketlenmiş resim',
		labeledText: 'Etiketlenmiş yazı',
		number: 'Sayı'
	},
	dataTypeItems: {
		audio: 'Ses',
		image: 'Resim',
		label: 'Etiket',
		number: 'Sayı',
		text: 'Yazı',
		video: 'Video'
	},
	decisionInputItems: {
		comparison: 'Karşılaştırma',
		passthrough: 'Veri geçişi'
	},
	draft: 'Taslak',
	file: 'Dosya',
	file_one: 'Dosya',
	file_other: 'Dosyalar',
	files: 'Dosyalar',
	fileStatusItems: {
		canceled: 'İptal edildi',
		canceling: 'İptal ediliyor',
		completed: 'Tamamlandı',
		failed: 'Başarısız',
		in_progress: 'İşleniyor',
		pending: 'Beklemede'
	},
	fileWithCount: '{{count}} dosya',
	fileWithId: 'Dosya {{id}}',
	finetune: 'FineTune',
	function: 'Fonksiyon',
	function_one: 'Fonksiyon',
	function_other: 'Fonksiyonlar',
	functionInputItems: {
		action: 'Eylem',
		apl_qfactor: 'Sıkıştırma kalite faktörü',
		audio: 'Ses',
		chunk_max_seconds: 'Maksimum parça süresi (saniye)',
		context: 'İçerik',
		data: 'Veri',
		dialect: 'Lehçe',
		dialect_in: 'Lehçe (girdi)',
		dialect_out: 'Lehçe (çıktı)',
		domain: 'Alan',
		enable_denormalizer: 'Denormalizatörü etkinleştir',
		featuretypes: '__Özellik çeşitleri',
		format: 'Biçim',
		frequency_penalty: '__Frekans cezası',
		gender: 'Cinsiyet',
		history: 'Geçmiş',
		image: 'Resim',
		inputtext: 'Giriş metni',
		is_medical: 'Tıbbi',
		language: 'Dil',
		lowercase_latin: 'Küçük harf Latince',
		max_duration_seconds: 'Maksimum süre (saniye)',
		max_new_tokens: 'Maksimum yeni token',
		max_tokens: 'Maksimum token',
		max_tokens_to_sample: 'Örneklenecek maksimum token',
		min_confidence: 'Minimum eminlik',
		min_duration_off: '__Minimum kapalı süre',
		min_duration_on: '__Minimum açık süre',
		modelid: '__Model No',
		next_state: 'Sonraki durum',
		normalize_arabic: 'Arapça\'yı normalleştir',
		num_return_sequences: 'Dönülecek dizi sayısı',
		numResults: 'Sonuç sayısı',
		offset: '__Ofset',
		onset: '__Onset',
		option_index: 'Seçenek dizini',
		output: 'Çıktı',
		payload: 'Yük',
		pitch: 'Ses perdesi',
		presence_penalty: '__Bulunma cezası',
		prompt: 'İstem',
		query: 'Sorgu',
		remove_accents: 'Aksanları kaldır',
		remove_arabic_diacritics: 'Arapça ayırıcı imleri kaldır',
		remove_arabic_superfluous: 'Arapça fazlalıkları kaldır',
		remove_punctuation: 'Noktalamayı kaldır',
		result_format: 'Sonuç biçimi',
		script: 'Alfabe',
		script_in: 'Alfabe (girdi)',
		script_out: 'Alfabe (çıktı)',
		seed: 'Tohum',
		session_id: 'Oturum no',
		settings: 'Ayarlar',
		similarity_boost: 'Benzerlik artışı',
		source_audio: 'Kaynak ses',
		source_supplier: 'Kaynak tedarikçi',
		sourcelanguage: 'Kaynak dil',
		speed: 'Hız',
		stability: 'Kararlılık',
		style: 'Stil',
		supplier_model_id: 'Tedarikçi model no',
		tags: 'Etiketler',
		target_supplier: 'Hedef tedarikçi',
		targetimage: 'Hedef görsel',
		targetlanguage: 'Hedef dil',
		targetlanguages: 'Hedef diller',
		temperature: 'Sıcaklık',
		template: 'Şablon',
		text: 'Yazı',
		top_k: 'Top K örnekleme değeri',
		top_p: 'Top P örnekleme değeri',
		transcript: 'Transkript',
		type: 'Tür',
		url: 'URL',
		video: 'Video',
		voice: 'İnsan sesi',
		voice_id: 'Ses no'
	},
	functionItems: {
		'activity-detection': 'Etkinlik tespiti',
		'asr-age-classification': '__ASR yaş sınıflandırması',
		'asr-gender-classification': '__ASR cinsiyet sınıflandırması',
		'asr-quality-estimation': '__ASR kalite tahmini',
		'audio-forced-alignment': '__Ses hizalama',
		'audio-generation-metric': '__Ses üretme metriği',
		'audio-reconstruction': '__Ses yapılandırması',
		'audio-source-separation': 'Ses kaynağı ayrıştırma',
		'audio-transcript-analysis': '__Ses transkript analizi',
		'audio-transcript-improvement': '__Ses transkript iyileştirmesi',
		'auto-mask-generation': 'Maske oluşturma',
		'benchmark-scoring-asr': '__ASR kıyaslama skorlaması',
		'benchmark-scoring-mt': '__MT kıyaslama skorlaması',
		'classification-metric': 'Sınıflandırma metriği',
		default: 'Varsayılan',
		'detect-language-from-text': 'Metinden dil tespiti',
		diacritization: 'Ayrıştırma',
		'dialect-detection': 'Aksan tanıma',
		'emotion-detection': 'Duygu tespiti',
		'entity-linking': 'Varlık bağlama',
		'entity-sentiment-analysis': 'Varlık duygu analizi',
		'expression-detection': 'İfade tespiti',
		'extract-audio-from-video': '__Videodan ses ayıklama',
		'facial-recognition': 'Yüz tanıma',
		'fill-text-mask': 'Yazı dolgusu maskeleme',
		'image-analysis': 'Görüntü analizi',
		'image-and-video-analysis': 'Görüntü ve video analizi',
		'image-captioning': 'Görüntü altyazısı',
		'image-compression': '__Görüntü sıkıştırma',
		'image-content-moderation': 'Görüntü içeriği moderasyonu',
		'image-label-detection': 'Görüntüden etiket tespiti',
		'image-manipulation': 'Görüntü manipülasyonu',
		'intent-recognition': 'Niyet tespiti',
		'keyword-extraction': 'Anahtar kelime çıkarma',
		'language-identification': 'Dil tespiti',
		'language-identification-audio': 'Sesten dil tespiti',
		loglikelihood: '',
		'metric-aggregation': '__Metrik birleştirme',
		'named-entity-recognition': 'İsimlendirilmiş varlık tanıma',
		'object-detection': 'Nesne tespiti',
		ocr: 'OCR',
		'offensive-language-identification': 'Saldırgan dil tespiti',
		paraphrasing: 'Değiştirerek yazma',
		'question-answering': 'Soru cevaplama',
		'referenceless-audio-generation-metric': '__Referanssız ses üretim metriği',
		'referenceless-text-generation-metric': '__Referanssız metin üretim metriği',
		'referenceless-text-generation-metric-default': '__Referanssız metin üretim metriği (varsayılan)',
		'scene-detection': 'Sahne algılama',
		'script-execution': '',
		search: 'Arama',
		'sentiment-analysis': 'Duygu analizi',
		'speaker-diarization-audio': '__Sesten konuşan ayırma',
		'speaker-diarization-video': '__Videodan konuşan ayırma',
		'speaker-recognition': '__Konuşan tanıma',
		'speech-classification': '__Konuşma sınıflandırma',
		'speech-embedding': '__Konuşma gömme',
		'speech-non-speech-classification': '__Konuşma/konuşmadışı sınıflandırma',
		'speech-recognition': '__Konuşma tanıma',
		'speech-synthesis': '__Konuşma sentezi',
		'speech-translation': '__Konuşma çevirisi',
		'split-on-linebreak': '__Satır sonundan bölme',
		'split-on-silence': '__Sessizlikten bölme',
		subtitling: 'Altyazılandırma',
		'subtitling-translation': 'Altyazılandırma çevirisi',
		summarization: 'Özetleme',
		'syntax-analysis': 'Sözdizimsel analiz',
		'table-question-answering': 'Tablodan soru cevaplama',
		'text-classification': 'Metin sınıflandırma',
		'text-content-moderation': 'Metin içeriği moderasyonu',
		'text-denormalization': '__Metin denormalizasyonu',
		'text-detection': '__Yazı tespiti',
		'text-embedding': '__Metin tabanlı özyerleşik',
		'text-generation': '__Metin üretimi (LLM)',
		'text-generation-metric': '__Metin üretim metriği',
		'text-generation-metric-aggregation': '__Metin üretim metriği (birleştirilmiş)',
		'text-generation-metric-default': '__Metin üretim metriği (varsayılan)',
		'text-normalization': 'Metin normalizasyonu',
		'text-reconstruction': '__Metin yapılandırması',
		'text-segmentation': 'Metin bölütleme',
		'text-spam-detection': 'Metinden spam tespiti',
		'text-summarization': '__Metin özetleme',
		'text-to-image-generation': 'Metinden resim üretimi',
		'text-transformation': 'Metin dönüştürme',
		tools: 'Araçlar',
		'topic-classification': 'Konu sınıflandırma',
		'topic-modeling': 'Konu modelleme',
		translation: 'Çeviri',
		utilities: 'Yardımcı servisler',
		'video-content-moderation': 'Video içerik moderasyonu',
		'video-forced-alignment': 'Video hizalama',
		'video-generation': 'Video üretme',
		'video-label-detection': 'Videodan etiket tespiti',
		'video-understanding': 'Video anlamlandırma',
		'viseme-generation': 'Viseme üretme',
		'voice-activity-detection': 'İnsan sesi aktivite tespiti',
		'voice-cloning': 'İnsan sesi klonlama',
		'zero-shot-classification': 'Sıfır-atış metin sınıflandırma'
	},
	functionOutputItems: {
		audio: 'Ses',
		confidence: 'Eminlik',
		data: 'Veri',
		image: 'Resim',
		input: 'Girdi',
		label: 'Etiket',
		score: 'Skor',
		text: 'Yazı',
		video: 'Video'
	},
	functions: 'Fonksiyon',
	functionWithCount: '{{count}} fonksiyon',
	hypotheses: 'Hipotezler',
	hypothesis: 'Hipotez',
	hypothesis_one: 'Hipotez',
	hypothesis_other: 'Hipotezler',
	input: 'Girdi',
	input_one: 'Girdi',
	input_other: 'Girdiler',
	inputLanguage: 'Girdi dili',
	inputLanguage_one: 'Girdi dili',
	inputLanguage_other: 'Girdi dilleri',
	inputLanguages: 'Girdi dilleri',
	inputLanguageWithCount: '{{count}} girdi dili',
	inputs: 'Girdiler',
	inputWithCount: '{{count}} girdi',
	label: 'Etiket',
	label_one: 'Etiket',
	label_other: 'Etiketler',
	labels: 'Etiketler',
	labelWithCount: '{{count}} etiket',
	language: 'Dil',
	language_one: 'Dil',
	language_other: 'Diller',
	languages: 'Diller',
	languageWithCount_one: '{{count}} dil',
	license: 'Lisans',
	metadata: 'Üst veri',
	metric: 'Metrik',
	metric_one: 'Metrik',
	metric_other: 'Metrikler',
	metricInputItems: {
		hypotheses: 'Hipotezler',
		references: 'Referanslar',
		score_identifier: 'Metrik tanımlayıcı',
		sources: 'Kaynaklar'
	},
	metrics: 'Metrikler',
	metricStatusItems: {
		deleted: 'Silinmiş',
		deleting: 'Siliniyor',
		disabled: 'Deaktif',
		enabling: 'Aktifleştiriliyor',
		failed: 'Başarısız',
		hidden: 'Gizli',
		onboarded: '__Eklendi',
		onboarding: '__Ekleniyor',
		training: 'Eğitiliyor'
	},
	metricWithCount: '{{count}} metrik',
	metricWithId: 'Metrik {{id}}',
	model: 'Model',
	model_one: 'Model',
	model_other: 'Modeller',
	modelNodeInstanceTypeItems: {
		ai: 'Yapay zeka',
		reconstructor: 'Birleştirici',
		segmentor: 'Bölütleyici',
		utility: 'Yardımcı'
	},
	models: 'Modeller',
	modelStatusItems: {
		deleted: 'Silinmiş',
		deleting: 'Siliniyor',
		disabled: 'Deaktif',
		enabling: 'Aktifleştiriliyor',
		failed: 'Başarısız',
		hidden: 'Gizli',
		onboarded: '__Eklendi',
		onboarding: '__Ekleniyor',
		training: 'Eğitiliyor'
	},
	modelWithCount: '{{count}} model',
	modelWithId: 'Model {{id}}',
	nodeTypeItems: {
		decision: 'Karar',
		function: 'Fonksiyon',
		input: 'Girdi',
		metric: 'Metrik',
		model: 'Model',
		output: 'Çıktı',
		router: '__Rota',
		script: 'Kod'
	},
	normalization: 'Normalizasyon',
	normalization_one: 'Normalizasyon',
	normalization_other: 'Normalizasyonlar',
	normalizationItems: {
		default: 'Varsayılan yapılandırma',
		'denormalize spoken text': 'Konuşma metnini denormalize et',
		'lowercase text': 'Küçük harfe çevir',
		'normalize default arabic': '__Varsayılan Arapça’yı normalize et',
		'normalize full arabic': '__Tam Arapça’yı normalize et',
		'normalize quotes': 'Tırnakları normalize et',
		'normalize spoken text': 'Konuşma metnini normalize et',
		'remove arabic superfluous': '__Gereksiz Arapça kelimeleri kaldır',
		'remove default arabic diacritics': '__Varsayılan Arapça ayırıcı imleri kaldır',
		'remove emails': 'E-posta adreslerini kaldır',
		'remove emojis': 'Emojileri kaldır',
		'remove full arabic diacritics': '__Tüm Arapça ayırıcı imleri kaldır',
		'remove html tags': 'HTML etiketlerini kaldır',
		'remove kashida dagger': 'Kashida Dagger’ı kaldır',
		'remove phone numbers': 'Telefon numaralarını kaldır',
		'remove punctuations': 'Noktalama işaretlerini kaldır',
		'remove urls': 'URL’leri kaldır',
		'tokenize text': '__Metni token’laştır'
	},
	normalizations: 'Normalizasyonlar',
	output: 'Çıktı',
	output_one: 'Çıktı',
	output_other: 'Çıktılar',
	outputLanguage: 'Çıktı dili',
	outputLanguage_one: 'Çıktı dili',
	outputLanguage_other: 'Çıktı dilleri',
	outputLanguages: 'Çıktı dilleri',
	outputLanguageWithCount: '{{count}} çıktı dili',
	outputs: 'Çıktılar',
	outputWithCount: '{{count}} çıktı',
	owner: 'Sahip',
	owner_one: 'Sahip',
	owner_other: 'Sahipler',
	owners: 'Sahipler',
	ownerWithCount: '{{count}} sahip',
	pipeline: 'Veri hattı',
	pipeline_one: 'Veri hattı',
	pipeline_other: 'Veri hatları',
	pipelineDraft: 'Veri hattı taslağı',
	pipelineDraft_one: 'Veri hattı taslağı',
	pipelineDraft_other: 'Veri hattı taslakları',
	pipelineDrafts: 'Veri hattı taslakları',
	pipelineDraftWithCount: '{{count}} veri hattı taslağı',
	pipelineDraftWithId: 'Veri hattı taslağı {{id}}',
	pipelines: 'Veri hatları',
	pipelineTemplate: 'Veri hattı şablonu',
	pipelineTemplate_one: 'Veri hattı şablonu',
	pipelineTemplate_other: 'Veri hattı şablonları',
	pipelineTemplates: 'Veri hattı şablonları',
	pipelineTemplateWithCount: '{{count}} veri hattı şablonu',
	pipelineTemplateWithId: 'Veri hattı şablonu {{id}}',
	pipelineWithCount: '{{count}} veri hattı',
	pipelineWithId: 'Veri hattı {{id}}',
	pricingTypeItems: {
		free: 'Ücretsiz',
		oneTime: 'Tek seferlik',
		perUse: 'Kullanım başına'
	},
	privacy: 'Gizlilik',
	privacyTypeItems: {
		private: 'Özel',
		public: 'Herkese açık',
		restricted: 'Kısıtlı'
	},
	reference: 'Referans',
	referenceless: 'Referanssız',
	report: 'Rapor',
	report_one: 'Rapor',
	report_other: 'Raporlar',
	reports: 'Raporlar',
	reportWithCount: '{{count}} rapor',
	reportWithId: 'Rapor {{id}',
	request: 'İstek',
	request_one: 'İstek',
	request_other: 'İstekler',
	requests: 'İstekler',
	requestWithCount: '{{count}} istek',
	resource: 'Kaynak',
	resource_one: 'Kaynak',
	resource_other: 'Kaynaklar',
	resources: 'Kaynaklar',
	resourceWithCount: '{{count}} kaynak',
	score: 'Skor',
	score_one: 'Skor',
	score_other: 'Skorlar',
	scores: 'Skorlar',
	segment: 'Bölüt',
	segment_one: 'Bölüt',
	segment_other: 'Bölütler',
	segmentCount: 'Bölüt sayısı',
	segments: 'Bölütler',
	segmentWithCount: '{{count}} bölüt',
	segmentWithIndex: '{{index}}. bölüt',
	source: 'Kaynak',
	status: 'Durum',
	subcategories: 'Alt kategoriler',
	subcategory: 'Alt kategori',
	subcategory_one: 'Alt kategori',
	subcategory_other: 'Alt kategoriler',
	subcategoryWithCount: '{{count}} alt kategori',
	submetric: 'Alt metrik',
	submetric_one: 'Alt metrik',
	submetric_other: 'Alt metrikler',
	submetrics: 'Alt metrikler',
	submetricWithCount: '{{count}} alt metrik',
	supplier: 'Tedarikçi',
	template: 'Şablon',
	token: 'Token',
	token_one: 'Token',
	token_other: 'Tokenler',
	tokens: 'Tokenler',
	tokenWithCount: '{{count}} token',
	user: 'Kullanıcı',
	user_one: 'Kullanıcı',
	user_other: 'Kullanıcılar',
	users: 'Kullanıcılar',
	userWithCount: '{{count}} kullanıcı',
	utilities: 'Yardımcılar',
	utility: 'Yardımcı',
	utility_one: 'Yardımcı',
	utility_other: 'Yardımcılar',
	utilityStatusItems: {
		deleted: 'Silinmiş',
		deleting: 'Siliniyor',
		disabled: 'Deaktif',
		enabling: 'Aktifleştiriliyor',
		failed: 'Başarısız',
		hidden: 'Gizli',
		onboarded: '__Eklendi',
		onboarding: '__Ekleniyor',
		training: 'Eğitiliyor'
	},
	utilityWithCount: '{{count}} yardımcı',
	utilityWithId: 'Yardımcı {{id}}',
	vendor: 'Sağlayıcı',
	vendor_one: 'Sağlayıcı',
	vendor_other: 'Sağlayıcılar',
	vendors: 'Sağlayıcılar',
	vendorWithCount: '{{count}} sağlayıcı',
	version: 'Versiyon',
	version_one: 'Versiyon',
	version_other: 'Versiyonlar',
	versions: 'Versiyonlar',
	versionWithCount: '{{count}} versiyon'
})

// Export
export default terminology
